import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchKycDetails(payload) {
  try {
    const url = paths.fetchKycDetails(); 
    const response = await axiosInstance.post(url, payload); 
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useFetchKycDetails = () => {
  return useMutation({
    mutationFn: fetchKycDetails, 
  });
};

export { useFetchKycDetails };